import { SegmentDetail } from '@fullstory/proto/fs/services/dx-objects';

export const nameAndIdCompare = (a: SegmentDetail, b: SegmentDetail) =>
  a.segment!.segment!.name.toLowerCase().localeCompare(b.segment!.segment!.name.toLowerCase()) ||
  a.segment!.segment!.id.localeCompare(b.segment!.segment!.id);

export const creatorCompare = (a: SegmentDetail, b: SegmentDetail) =>
  a.segment!.metadata!.createdBy.localeCompare(b.segment!.metadata!.createdBy.toLowerCase()) ||
  nameAndIdCompare(a, b);
